import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Divider,
  IconButton,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { v1 as uuidv1 } from "uuid";
import VideoSnapshot from "video-snapshot";
import AppDataContext from "../../../common/appContext";
import { Role } from "../../../helper";
import PlayerImg from "../../../images/player.png";
import { UserDataService } from "../../../services";
import uploadFileToBlob, {
  baseUrl,
  uploadVideoToBlobWithProgress,
  Video_baseUrl,
} from "../../../services/AzureStorage";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import ButtonContainer from "../../../sharedComponents/buttoncontainer/buttonContainer";
import CustomDialog from "../../../sharedComponents/dialog/dialog";
import JWPlayer from "../../../sharedComponents/JWPlayer/JWPlayer";
import JWPlayerInterview from "../../../sharedComponents/JWPlayer/JWPlayerInterview";
import Progressbar from "../../../sharedComponents/uploadFile/progressbar";
import UploadFile from "../../../sharedComponents/uploadFile/uploadFile";
import VideoJSPlayerInterview from "../../../sharedComponents/videoPlayer/VideoJSPlayerInterview";

const useStyles = makeStyles((theme) => ({
  mainContent: {
    "& .jwplayer": {
      [theme.breakpoints.up("md")]: {
        width: "800px !important",
        height: "440px !important",
      },
    },
  },
  paperWidth: {
    width: "640px",
    [theme.breakpoints.up("md")]: {
      width: "800px",
    },
  },
  btnselected: {
    backgroundColor: "#C8102E", //"#1d428a",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#C8102E",
    },
  },
  btnunselected: {
    backgroundColor: "#707070",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#707070",
    },
  },
}));
// var btn1=false;
// var btn2=false;
// var btn3=false;
// var btn4=false;
// var btn5=false;
export default function PlayerInterviewContainer(props) {
  const classes = useStyles();
  const { setLoading, setAlert, setAlertType, setAlertMessage } = props;
  const { user, selectedEventId } = useContext(AppDataContext);
  const [playerYear, setplayerYear] = useState([{}]);
  let userAppRoles = user.appRoles || [];
  const [interviewVideoList, setInterviewVideoList] = useState([]);
  const params = useParams();
  const [currentPlay, setCurrentPlay] = useState({ videoUrl: "" });
  const [openUpload, setOpenUpload] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [showFileUploadProgressBar, setShowFileUploadProgressBar] =
    useState(false);
  const [fileSourceName, setFileSourceName] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileUploadedResponse, setFileUploadedResponse] = useState(false);
  const [isFileDetailSavedToDB, setIsFileDetailSavedToDB] = useState(false);
  const [thumbnailFileName, setThumbnailFileName] = useState("");
  const [isUploadingInProgress, setIsUploadingInProgress] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [FileID, setFileID] = useState(0);
  const [btn1, setbtn1] = useState(false);
  const [btn2, setbtn2] = useState(false);
  const [btn3, setbtn3] = useState(false);
  const [btn4, setbtn4] = useState(false);
  const [btn5, setbtn5] = useState(false);
  const handleClose = () => {
    setOpenUpload(false);
  };
  // useEffect(() => {
  //   console.log("currentPlay", currentPlay);
  // }, [currentPlay]);

  async function LoadInterviewdata() {
    try {
      setLoading(true);
      let response = await UserDataService.getPlayerFileDetails(
        selectedEventId,
        params.playerId,
        user?.loginID
      );
      // console.log("getPlayerFileDetails-response", response.data.length);
      setInterviewVideoList(response.data);
      if (response?.data[0]?.fileType === "V" && response?.data?.length > 0)
        setCurrentPlay({
          videoUrl: Video_baseUrl(response.data[0].fileName),
        });
    } finally {
      setLoading(false);
      setIsFileDetailSavedToDB(false);
      setIsUploadingInProgress(false);
    }
  }
  async function LoadInterviewdataonYearClicked(yeareventId) {
    try {
      setLoading(true);
      let response = await UserDataService.getPlayerFileDetails(
        yeareventId,
        params.playerId,
        user?.loginID
      );
      // console.log("getPlayerFileDetails-response", response.data.length);
      setInterviewVideoList(response.data);
      if (response.data[0].fileType == "V" && response.data.length > 0)
        setCurrentPlay({
          videoUrl: Video_baseUrl(response.data[0].fileName),
        });
    } finally {
      setLoading(false);
      setIsFileDetailSavedToDB(false);
      setIsUploadingInProgress(false);
    }
  }

  useEffect(() => {
    LoadInterviewdata();
    setbtn1(false);
    setbtn2(false);
    setbtn3(false);
    setbtn4(false);
    setbtn5(false);
    PlayerProfileService.getAnthrosDataByPlayerYear(
      selectedEventId,
      params.playerId
    ).then((response) => {
      //console.log("setCombineYearDropdownData ", response.data);

      setplayerYear(response.data);
      var pdata = response.data;
      pdata.map((item, index) => {
        if (item.eventId === selectedEventId + "" && index == 0) {
          setbtn1(true); //btn1=true;
        } else if (item.eventId === selectedEventId + "" && index == 1) {
          setbtn2(true); // btn2=true;
        } else if (item.eventId === selectedEventId + "" && index == 2) {
          setbtn3(true); // btn2=true;
        } else if (item.eventId === selectedEventId + "" && index == 3) {
          setbtn4(true); //btn4=true;
        } else if (item.eventId === selectedEventId + "" && index == 4) {
          setbtn5(true); // btn5=true;
        }
      });
    });
  }, [selectedEventId]);

  useEffect(() => {
    if (isFileDetailSavedToDB) LoadInterviewdata();
  }, [user, selectedEventId, isFileDetailSavedToDB]);

  async function extractThumbnail(file) {
    try {
      const snapshoter = new VideoSnapshot(file);
      const previewSrc = await snapshoter.takeSnapshot(3);

      let newFileName = uuidv1() + ".png";
      setThumbnailFileName(newFileName);

      fetch(previewSrc)
        .then((res) => res.blob())
        .then((blob) => {
          const thumbnailFile = new File([blob], newFileName, {
            type: "image/png",
          });
          uploadThumbnailFile(thumbnailFile);
        });
    } catch (e) {
      console.log("Error - extractThumbnail", e);
    }
  }

  async function uploadThumbnailFile(file) {
    try {
      await uploadFileToBlob(file);
      //console.log("snapshot file Uploaded");
    } catch (e) {
      console.log("Error - uploadThumbnailFile", e);
    }
  }

  async function uploadFile(file) {
    const fileUploaded = await uploadVideoToBlobWithProgress(
      file,
      setProgressValue
    );
    //console.log("fileUploaded", fileUploaded);
    setFileUploadedResponse(fileUploaded);
  }

  async function saveFileDetailsToDB() {
    try {
      setLoading(true);
      let formObj = {
        fileID: 0,
        playerID: params.playerId,
        eventId: selectedEventId + "",
        fileType: "V",
        fileName: fileName,
        displayName: fileSourceName,
        thumbnailName: thumbnailFileName,
        userBy: user.loginID,
      };

      await PlayerProfileService.savePlayerFileDetails(formObj);
      setIsFileDetailSavedToDB(true);
    } finally {
      setLoading(false);
      setFileUploadedResponse(false);
      setProgressValue(0);
    }
  }

  const processPlayerInterviewFile = (file) => {
    //console.log(file);

    // if (file.size >= 200000000) {
    //   setAlertMessage("File is too big. Max 200 mb");
    //   setAlertType("error");
    //   setAlert(true);
    // } else {
    (async () => {
      if (file) {
        try {
          setIsUploadingInProgress(true);
          setFileName(file.name);
          await extractThumbnail(file);

          setShowFileUploadProgressBar(true);
          await uploadFile(file);

          setAlertMessage("File saved successfully.");
          setAlertType("success");
          setAlert(true);
        } catch (e) {
          console.log("error", e);
          setAlertMessage("File saving failed.");
          setAlertType("error");
          setAlert(true);
        } finally {
          handleClose();
          setShowFileUploadProgressBar(false);
        }
      }
    })();
    handleClose();
    //}
  };

  useEffect(() => {
    if (fileUploadedResponse) {
      //console.log("use effect fileUploadedResponse", fileUploadedResponse);
      saveFileDetailsToDB();
    }
  }, [fileUploadedResponse]);

  const handleDialogCancel = () => {
    setOpenDialog(false);
  };

  const renderDialogActions = () => (
    <ButtonContainer
      handleClick={delPlayerFileDetails}
      handleCancel={handleDialogCancel}
      buttonText={"Delete"}
    />
  );

  const renderDialogContent = () => (
    <Typography variant="body1">
      Are you sure you want to delete this file?
    </Typography>
  );

  async function delPlayerFileDetails() {
    try {
      setOpenDialog(false);
      setLoading(true);
      await PlayerProfileService.delPlayerFileDetails(FileID);
      setIsFileDetailSavedToDB(true);
    } finally {
      setLoading(false);
      setFileUploadedResponse(false);
      setFileID(0);
    }
  }
  const getyearValue = (playerEventId, index) => {
    if (index === 0) {
      setbtn1(true);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false);
      //  btn1=true;btn2=false;btn3=false;btn4=false;btn5=false;
    } else if (index === 1) {
      setbtn1(false);
      setbtn2(true);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=true;btn3=false;btn4=false;btn5=false;
    } else if (index === 2) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(true);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=false;btn3=true;btn4=false;btn5=false;
    } else if (index === 3) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(true);
      setbtn5(false); //btn1=false;btn2=false;btn3=false;btn4=true;btn5=false;
    } else if (index === 4) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(true); // btn1=false;btn2=false;btn3=false;btn4=false;btn5=true;
    }
    LoadInterviewdataonYearClicked(playerEventId);
  };
  return (
    <Container>
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent="center"
        mt={1}
        mb={1}
      >
        {playerYear.length > 1
          ? playerYear.map((item, index) => {
              if (index === 0) {
                return (
                  <>
                    <Typography
                      variant="h6"
                      fontStyle="italic"
                      mr={2}
                      color={"primary"}
                    >
                      Details available for{" "}
                    </Typography>
                    <Button
                      onClick={() => getyearValue(item.eventId, index)}
                      key={index}
                      className={
                        btn1 === true
                          ? classes.btnselected
                          : classes.btnunselected
                      }
                    >
                      Year {item.eventYear}
                    </Button>
                  </>
                );
              } else if (index === 1) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn2 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 2) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn3 === true
                        ? classes.btnselected
                        : classes.btndeselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 3) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn4 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 4) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn5 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn5 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    {item.eventYear}
                  </Button>
                );
              }
            })
          : ""}
      </Box>
      <Box display="flex" justifyContent="center">
        <Box component="main" className={classes.mainContent} m={1}>
          {currentPlay.videoUrl == null || currentPlay.videoUrl == "" ? (
            <img src={PlayerImg} />
          ) : (
            <VideoJSPlayerInterview
              fileURL={`${currentPlay.videoUrl}`}
              playExternalVideo={true}
              fileName={FileID}
              isFromPlayerInterview
            />
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Paper
          sx={{ alignSelf: "center", marginBottom: "8px" }}
          className={classes.paperWidth}
        >
          <Box display="flex" m={2}>
            <Box display="flex" m={1} alignItems="center">
              {userAppRoles.includes(Role.Admin) ||
              userAppRoles.includes(Role.League) ? (
                <>
                  <Typography variant="h6" fontWeight="medium" color="primary">
                    Upload File:{" "}
                  </Typography>
                  <IconButton
                    onClick={() => setOpenUpload(true)}
                    disabled={isUploadingInProgress}
                  >
                    <CloudUploadIcon sx={{ fontSize: "40px" }} />
                  </IconButton>
                </>
              ) : (
                ""
              )}
            </Box>

            {showFileUploadProgressBar && (
              <Box display="flex" ml={0.5} alignItems="center">
                <Box>
                  <Typography variant="caption" color="primary" mr={1}>
                    {fileSourceName}
                  </Typography>
                  <Typography variant="caption" color="green" mr={1}>
                    {progressValue < 100 ? `- Uploading...` : `- Saving...`}
                  </Typography>
                </Box>

                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <Progressbar progressVal={progressValue} />
                </Box>
              </Box>
            )}
          </Box>
        </Paper>
        <Divider />
        <Box display="flex" p={1} justifyContent="center">
          {interviewVideoList &&
            interviewVideoList.map((row, index) => {
              if (row.fileType == "V") {
                return (
                  <Card
                    sx={{
                      maxWidth: 345,
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                    key={`ivc_${index}`}
                    elevation={2}
                  >
                    <CardMedia
                      component="img"
                      height="140"
                      image={baseUrl(row.thumbnailName)}
                      onClick={() =>
                        setCurrentPlay({
                          videoUrl: Video_baseUrl(row.fileName),
                        })
                      }
                    />
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant="subtitle2"
                        component="div"
                      >
                        {row.displayName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {row.createdDate}
                      </Typography>
                    </CardContent>
                    <CardActions
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                      }}
                    >
                      <Divider width="50%" />
                      {userAppRoles.includes(Role.Admin) ||
                      userAppRoles.includes(Role.League) ? (
                        <IconButton
                          aria-label="delete interview"
                          color="secondary"
                          onClick={() => {
                            setFileID(row.fileID);
                            setOpenDialog(true);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      ) : (
                        ""
                      )}
                    </CardActions>
                  </Card>
                );
              }
            })}
        </Box>
      </Box>
      {openUpload && (
        <UploadFile
          open={openUpload}
          title="Upload File"
          handleClose={handleClose}
          changeFile={processPlayerInterviewFile}
          acceptableFileFormats=".mp4,.mov"
          handleSourceFileName={setFileSourceName}
        />
      )}
      <CustomDialog
        title={"Confirm File Delete"}
        handleClose={handleDialogCancel}
        open={openDialog}
        fullWidth={true}
        renderContent={renderDialogContent}
        renderActions={renderDialogActions}
      />
    </Container>
  );
}
